import { render, staticRenderFns } from "./RoleTypeSelect.vue?vue&type=template&id=43621758"
import script from "./RoleTypeSelect.vue?vue&type=script&lang=js"
export * from "./RoleTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports